import React, { useMemo, useState } from 'react';
import { MOCK_BROWSER_VARIANTS } from '../../mocks';
import { BarcodeStatusBadge, RequestVerificationButton } from '../../components/common/BarcodeVerification';

export const VariantBrowserPage: React.FC = () => {
  const [search, setSearch] = useState('');

  const filtered = useMemo(() => {
    if (!search) return MOCK_BROWSER_VARIANTS;
    const q = search.toLowerCase();
    return MOCK_BROWSER_VARIANTS.filter(
      (v) =>
        v.id.toLowerCase().includes(q) ||
        v.itemNumber.toLowerCase().includes(q) ||
        v.chain.toLowerCase().includes(q)
    );
  }, [search]);

  const statusColor = (status: string) => {
    switch (status) {
      case 'active':
        return 'var(--positive)';
      case 'merged':
        return 'var(--blue)';
      case 'archived':
        return 'var(--text-tertiary)';
      default:
        return 'var(--text-secondary)';
    }
  };

  return (
    <div className="page-content">
      <div style={{ marginBottom: 20 }}>
        <h2 style={{ fontSize: 18, fontWeight: 700 }}>Variant Browser</h2>
      </div>

      <div style={{ marginBottom: 16 }}>
        <input
          className="forge-search-input"
          placeholder="Search by variant ID, item number, or chain..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>

      <table className="admin-table">
        <thead>
          <tr>
            <th>Variant ID</th>
            <th>Item Number</th>
            <th>Chain</th>
            <th>Crops</th>
            <th>Status</th>
            <th>Barcode</th>
            <th>Verify</th>
          </tr>
        </thead>
        <tbody>
          {filtered.map((v) => (
            <tr key={v.id}>
              <td style={{ fontFamily: 'var(--font-mono)', fontWeight: 600, color: 'var(--accent)' }}>
                {v.id}
              </td>
              <td style={{ fontFamily: 'var(--font-mono)', fontSize: 12, color: 'var(--text-secondary)' }}>
                {v.itemNumber}
              </td>
              <td>{v.chain}</td>
              <td style={{ fontFamily: 'var(--font-mono)' }}>{v.cropCount}</td>
              <td>
                <span style={{ fontFamily: 'var(--font-mono)', fontSize: 12, fontWeight: 600, color: statusColor(v.status) }}>
                  {v.status}
                </span>
              </td>
              <td>
                <BarcodeStatusBadge status={v.barcodeStatus} />
              </td>
              <td>
                <RequestVerificationButton
                  status={v.barcodeStatus}
                  variantId={v.id}
                  onRequest={(id) => console.log('Verification requested for', id)}
                />
              </td>
            </tr>
          ))}
          {filtered.length === 0 && (
            <tr>
              <td colSpan={7} style={{ textAlign: 'center', color: 'var(--text-tertiary)', padding: 32 }}>
                No variants found
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};
